import React from "react";
import "./StatsCard.css";

type Color = "blue" | "green" | "amber" | "gray" | "maroon";

interface StatsCardProps {
  title:     string;
  value:     number | string;
  subtitle?: string;
  color?:    Color;
}

export default function StatsCard({ title, value, subtitle, color = "gray" }: StatsCardProps) {
  return (
    <div className={`aro-stats-card aro-stats-card--${color}`}>
      <span className="aro-stats-card__value">{value}</span>
      <span className="aro-stats-card__title">{title}</span>
      {subtitle && <span className="aro-stats-card__subtitle">{subtitle}</span>}
    </div>
  );
}
